/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.ursascheduler.SchedulerSource
*/
export var SchedulerSource;
(function (SchedulerSource) {
    SchedulerSource["PROJECT"] = "PROJECT";
    SchedulerSource["TENANT"] = "TENANT";
})(SchedulerSource || (SchedulerSource = {}));
//# sourceMappingURL=SchedulerSource.js.map